import React, { useEffect } from 'react';

import { Body } from '@depop/web-thrift-ui/Typography';
import { TimeIcon } from '@depop/web-ui-kit/Icons/TimeIcon';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { InfoBanner } from '@/components/InfoBanner';
import { ActivityTrackerEventType } from '@/modules/activityTracker/constants';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

type Props = {
  username: string;
  sellerId: string;
  productIds: string[];
};

export function SellerVacationBanner({
  username,
  sellerId,
  productIds,
}: Props) {
  const t = useTranslations('checkout');
  const [, user] = useCurrentUser();
  const { sendActivityTrackerEvent } = useActivityTracker({ userId: user?.id });

  useEffect(() => {
    sendActivityTrackerEvent(
      ActivityTrackerEventType.BAG_VACATION_MODE_NUDGE_VIEW,
      {
        schemaVersion: '1.0',
        bag: '',
        sellerId,
        productIds,
      }
    );
  }, [sendActivityTrackerEvent, sellerId, productIds]);

  return (
    <InfoBanner
      className={styles.sellerVacationBanner}
      Icon={({ className }) => <TimeIcon size={16} className={className} />}
      message={t.rich('Error.SellerVacation', {
        bold: () => (
          <Body variant="sm-bold" as="span">
            {username}
          </Body>
        ),
      })}
    />
  );
}
